import React from "react";

import EducationHero from "./Hero/educationHero";
import Schools from "./Schools/schools";
import Certifications from "./Certificates/certificates";

const Eduction = () => {
  return (
    <div>
      <EducationHero />
      <Schools />
      <Certifications />
    </div>
  );
};

export default Eduction;
